import _ from 'underscore';
import platformUtilities from '../../modules/platform_utilities.js';
import FlightDatesHelper from '../../modules/flight_dates_helper.js';
import { refreshBudgetAllocationAttributeDisables } from '../../modules/budget_allocation_attribute_disabler.js';

angular.module('vastdesk').
  component('budgetSpend', {
    bindings: {
      spendId: '@',
      rateCurrency: '@',
      currencyMetrics: '<',
      valuesOnlyClassMap: '<',
      multiCurrencyEnabled: '<',
      defaultMetric: '@',
      defaultVastCachingToTrue: '@',
      initialCampaignBudgets: '@',
      demandEnvironment: '@',
      publisherAccount: '@'
    },
    controller: ['$element', '$rootScope', '$compile', function($element, $rootScope, $compile) {

      var self = this;
      var bodySelector = $('body');
      var budgetsElement;
      var flightDatesElement = $('#flight_dates');
      const flightDatesHelper = new FlightDatesHelper();
      let budgetFlightDatesInactive = false;
      let refreshBudgetAllocationAttributeDisablesTimeout;
      const PERCENTAGE_ALLOCATION_TYPE = '%_allocation';
      const BUDGET_CAP_ALLOCATION_TYPE = 'budget_cap';
      const PERCENTAGE_ALLOCATION_TOOLTIP = 'All budgets must use % allocation';
      const BUDGET_CAP_ALLOCATION_TOOLTIP = 'All budgets must use Budget Cap';
      const DOMAIN_LIST_OBJECT = 'DomainList';
      const DOMAIN_BREAKDOWN_DISABLED_ENVIRONMENTS = ['nil', 'ctv'];
      const CURRENCY_METRICS = ['revenue', 'gross_cost', 'net_cost'];
      var typeToLabelMap = {
        'revenue': 'Revenue:',
        'requests': 'Requests:',
        'impressions': 'Impressions:',
        'completes': 'Completes:',
        'clicks': 'Clicks:',
        'net_cost': 'Net Cost:',
        'gross_cost': 'Gross Cost:',
        'bid_requests': 'Bid Requests:'
      };
      var typeToClassMap = {
        'revenue': 'btn-rev',
        'requests': 'btn-reqs',
        'impressions': 'btn-imps',
        'completes': 'btn-completes',
        'clicks': 'btn-clicks',
        'net_cost': 'btn-net-cost',
        'gross_cost': 'btn-gross-cost',
        'bid_requests': 'btn-bid-requests',
      };

      const getEnvDisabledObjects = function() {
        return self.publisherAccount === 'true' && self.demandEnvironment && _.includes(DOMAIN_BREAKDOWN_DISABLED_ENVIRONMENTS, self.demandEnvironment)
               ? [DOMAIN_LIST_OBJECT]
               : [];
      };

      const clearDomainBreakdownSelections = function(scope) {
        if (self.publisherAccount !== 'true' || !_.includes(DOMAIN_BREAKDOWN_DISABLED_ENVIRONMENTS, self.demandEnvironment)) {
          return;
        }

        const $scope = scope && scope.length ? scope : budgetsElement || bodySelector;
        $scope.find('.budget-cap-card, .budget-allocation-card').find('.budget-cap-allocation-object select').each(function() {
          const $select = $(this);
          if ($select.val() === DOMAIN_LIST_OBJECT) {
            $select.val('').trigger('change');
          }
        });
      };

      const scheduleBudgetAllocationAttributeRefresh = function(scope) {
        clearTimeout(refreshBudgetAllocationAttributeDisablesTimeout);
        refreshBudgetAllocationAttributeDisablesTimeout = setTimeout(function() {
          refreshBudgetAllocationAttributeDisables(scope || budgetsElement || bodySelector, {
            envDisabledObjects: getEnvDisabledObjects()
          });
        }, 0);
      };

      const cleanNumber = (value) => {
        if (value == null) return '';

        // strip all non-numeric and non-decimal characters
        return value.replace(/[^\d.]/g, '');
      };

      const isCurrencyMetric = function(metric) {
        return CURRENCY_METRICS.includes(metric);
      };

      const visibleBudgetForms = function() {
        return budgetsElement.find('.budget-group.add_form:not([style*="display: none"])').not('.hidden');
      };

      const visibleBudgetAllocations = function(add_form) {
        return add_form.find('.budget-allocations:not([style*="display: none"])').not('.hidden');
      };

      const allocationBreakdownEnabled = function(add_form) {
        return add_form.find('.allocation-breakdown input').is(':checked');
      };

      const selectedAllocationType = function(add_form) {
        return add_form.find('.allocation-type input[type="radio"]:checked').val();
      };

      const budgetUsesPercentageAllocation = function(add_form) {
        return allocationBreakdownEnabled(add_form) && selectedAllocationType(add_form) === PERCENTAGE_ALLOCATION_TYPE;
      };

      const percentageAllocationReferenceAttributes = function(excludedForm) {
        const forms = visibleBudgetForms();

        for (let i = 0; i < forms.length; i += 1) {
          const add_form = $(forms[i]);
          if (excludedForm && add_form.get(0) === excludedForm.get(0)) {
            continue;
          }
          if (!budgetUsesPercentageAllocation(add_form)) {
            continue;
          }

          const attrs = _.chain(visibleBudgetAllocations(add_form))
            .map(function(allocationRow) {
              const $row = $(allocationRow);
              const object = $row.find('.budget-cap-allocation-object select').val();
              if (!object) {
                return null;
              }

              const sourceType = $row.find('.budget-cap-allocation-source-type input:checked').val() || 'values';
              return { object: object, sourceType: sourceType };
            })
            .compact()
            .value();

          if (attrs.length) {
            return attrs;
          }
        }

        return [];
      };

      const applyPercentageAllocationReferenceAttributes = function(add_form) {
        const hasConfiguredAllocationAttributes = _.some(visibleBudgetAllocations(add_form).toArray(), function(allocationRow) {
          return Boolean($(allocationRow).find('.budget-cap-allocation-object select').val());
        });
        if (hasConfiguredAllocationAttributes) {
          return;
        }

        const referenceAttributes = percentageAllocationReferenceAttributes(add_form);
        if (!referenceAttributes.length) {
          return;
        }

        const addButton = add_form.find('.add_budget_allocation');
        if (addButton.length) {
          let safetyCounter = 0;
          while (visibleBudgetAllocations(add_form).length < referenceAttributes.length && safetyCounter < 20) {
            addButton.trigger('click');
            safetyCounter += 1;
          }
        }

        setTimeout(function() {
          const rows = visibleBudgetAllocations(add_form);
          referenceAttributes.forEach(function(referenceAttribute, index) {
            const row = $(rows[index]);
            if (!row.length) {
              return;
            }

            const sourceInput = row.find(`.budget-cap-allocation-source-type input[value="${referenceAttribute.sourceType}"]`);
            if (sourceInput.length && !sourceInput.is(':checked')) {
              sourceInput.closest('label').click();
            }

            const objectSelect = row.find('.budget-cap-allocation-object select');
            if (objectSelect.length) {
              objectSelect.val(referenceAttribute.object).trigger('change');
            }
          });
        }, 0);
      };

      const clearAllocationTypeDisable = function(add_form) {
        add_form.find('.allocation-type .btn-group label').each(function() {
          const $label = $(this);
          $label.removeClass('disabled')
                .find('input[type="radio"]').prop('disabled', false);
          $label.tooltip('dispose')
                .removeAttr('title')
                .removeAttr('data-placement');
        });
      };

      const setAllocationTypeDisable = function(add_form, typeToDisable, tooltipText) {
        const $input = add_form.find(`.allocation-type input[type="radio"][value="${typeToDisable}"]`);
        if (!$input.length) {
          return;
        }
        const $label = $input.closest('label');
        $input.prop('disabled', true);
        $label.addClass('disabled')
              .attr('title', tooltipText)
              .attr('data-placement', 'top')
              .tooltip();
      };

      const syncAllocationTypeUI = function() {
        const allocationForms = visibleBudgetForms().toArray().filter(function(form) {
          return allocationBreakdownEnabled($(form));
        });

        if (!allocationForms.length) {
          return;
        }

        const leaderFormElement = _.find(allocationForms, function(form) {
          return Boolean(selectedAllocationType($(form)));
        });

        if (!leaderFormElement) {
          allocationForms.forEach(function(form) {
            clearAllocationTypeDisable($(form));
          });
          return;
        }

        const leaderType = selectedAllocationType($(leaderFormElement));
        const oppositeType = leaderType === PERCENTAGE_ALLOCATION_TYPE
          ? BUDGET_CAP_ALLOCATION_TYPE
          : PERCENTAGE_ALLOCATION_TYPE;
        const tooltipText = leaderType === PERCENTAGE_ALLOCATION_TYPE
          ? PERCENTAGE_ALLOCATION_TOOLTIP
          : BUDGET_CAP_ALLOCATION_TOOLTIP;

        allocationForms.forEach(function(form) {
          const add_form = $(form);
          clearAllocationTypeDisable(add_form);

          if (form === leaderFormElement) {
            return;
          }

          setAllocationTypeDisable(add_form, oppositeType, tooltipText);

          const currentType = selectedAllocationType(add_form);
          if (currentType && currentType !== leaderType) {
            const targetLabel = add_form.find(`.allocation-type input[type="radio"][value="${leaderType}"]`).closest('label');
            if (targetLabel.length) {
              targetLabel.click();
            }
          }
        });
      };


      const togglePacingFields = function(add_form) {
        setTimeout(function() {
          const budgetPeriod = add_form.find('.budget-period input:checked').val();
          const flightDateEnabled = $('.flight-dates input:checked').val();
          const noFlightDates = flightDateEnabled !== 'true' && visibleBudgetFlightDates(add_form).length < 1;

          if (budgetPeriod === 'lifetime' && noFlightDates) {
            add_form.find('.budget_pacing .btn-group label[for$=budget_pacing_]').click()
                                                                                 .removeClass('disabled')
                                                                                 .tooltip('dispose')
                                                                                 .removeAttr('title')
                                                                                 .removeAttr('data-placement');
            add_form.find('.budget_pacing .btn-group label[for*=budget_pacing_smooth]').addClass('disabled')
                                                                                       .attr('title', 'Add Flight Dates to apply pacing to Lifetime budgets')
                                                                                       .attr('data-placement', 'top')
                                                                                       .tooltip('dispose')
                                                                                       .tooltip();
            add_form.find('.budget_pacing .btn-group label[for*=budget_pacing_front_loaded]').addClass('disabled')
                                                                                             .attr('title', 'Add Flight Dates to apply pacing to Lifetime budgets')
                                                                                             .attr('data-placement', 'top')
                                                                                             .tooltip('dispose')
                                                                                             .tooltip();
          }
          else if (budgetPeriod === 'custom' && noFlightDates) {
            add_form.find('.budget_pacing .btn-group label').addClass('disabled')
                                                            .attr('title', 'Add Flight Dates to apply pacing to Custom budgets')
                                                            .attr('data-placement', 'top')
                                                            .tooltip('dispose')
                                                            .tooltip();
          }
          else {
            add_form.find('.budget_pacing .btn-group label[for$=budget_pacing_]').removeClass('disabled')
                                                                                 .tooltip('dispose')
                                                                                 .removeAttr('title')
                                                                                 .removeAttr('data-placement');
            add_form.find('.budget_pacing .btn-group label[for*=budget_pacing_smooth]').removeClass('disabled')
                                                                                       .tooltip('dispose')
                                                                                       .removeAttr('title')
                                                                                       .removeAttr('data-placement');
            add_form.find('.budget_pacing .btn-group label[for*=budget_pacing_front_loaded]').removeClass('disabled')
                                                                                             .tooltip('dispose')
                                                                                             .removeAttr('title')
                                                                                             .removeAttr('data-placement');
          }

        }, 0);
      };

      const updateBudgetCapLabels = function(addForm, selectedType) {
        addForm.find('.budget-cap-metric-value-label').each(function() {
          $(this).text(typeToLabelMap[selectedType]);
        });


        addForm.find('.budget-caps:not([style*="display: none"])').each(function(budgetCapIndex, budgetCap) {
          var $budgetCap = $(budgetCap);
          $budgetCap.find('.budget-cap-budget-type .btn').not('.btn-percent').addClass('hidden');

          var buttonToShow = $budgetCap.find('.budget-cap-budget-type .' + typeToClassMap[selectedType]);
          buttonToShow.removeClass('hidden');

          if ($budgetCap.find('.budget-cap-budget-type .btn-percent').hasClass('active')) {
            return;
          }

          $budgetCap.find('.budget-cap-budget-type .btn').removeClass('active');

          var fallbackBtn = $budgetCap.find('.budget-cap-budget-type .btn').not('.btn-percent').not('.hidden');

          if (fallbackBtn.length) {
            fallbackBtn.addClass('active');
            fallbackBtn.find('input[type="radio"]').prop('checked', true);
          }
        });
      };

      const applyFormatToBudgetMetrics = function(add_form, format) {
        const budgetMetric = add_form.find('.budget-metric');
        if (!budgetMetric.length) return;

        const completesLabel = budgetMetric.find('label[for*=budget_metric_completes]');
        const clicksLabel = budgetMetric.find('label[for*=budget_metric_clicks]');
        const completesInput = budgetMetric.find('input[id*=budget_metric_completes]');
        const clicksInput = budgetMetric.find('input[id*=budget_metric_clicks]');

        const hideCompletes = ['tile', 'display'].includes(format);
        const hideClicks = format === 'audio';

        completesLabel.toggleClass('hidden', hideCompletes);
        completesInput.prop('disabled', hideCompletes);
        clicksLabel.toggleClass('hidden', hideClicks);
        clicksInput.prop('disabled', hideClicks);

        const currentMetric = budgetMetric.find('input[id*=budget_metric]:checked').val();
        const selectionInvalid = (hideCompletes && currentMetric === 'completes') ||
                                 (hideClicks && currentMetric === 'clicks');
        if (!selectionInvalid) return;

        var fallbackLabel = budgetMetric.find('label[for*=budget_metric_' + self.defaultMetric + ']');
        if (!fallbackLabel.length) return;

        budgetMetric.find('label.btn').removeClass('active');
        fallbackLabel.addClass('active');
        fallbackLabel.find('input[type="radio"]').prop('checked', true).trigger('change');
      };

      const toggleMetricFields = function(add_form) {
        setTimeout(function() {
          const budgetMetric = add_form.find('.budget-metric');
          const completesInput = budgetMetric.find('input[id*=budget_metric_completes]');
          const clicksInput = budgetMetric.find('input[id*=budget_metric_clicks]');
          const allocationBreakdownInput = add_form.find('.allocation-breakdown input');
          const allocationLabel = add_form.find('label[for*=allocation_breakdown]');
          const labelsToToggle = budgetMetric.find('label[for*=budget_metric_clicks], label[for*=budget_metric_completes]');

          const isDisabled = completesInput.is(':checked') || clicksInput.is(':checked');

          allocationBreakdownInput.prop('disabled', isDisabled);
          allocationLabel.toggleClass('disabled-checkbox', isDisabled);

          if (isDisabled) {
            allocationLabel.attr('title', 'Not available for clicks or completes')
                .attr('data-placement', 'top')
                .tooltip();
          } else {
            allocationLabel.tooltip('dispose').removeAttr('title').removeAttr('data-placement');
          }

          labelsToToggle.toggleClass('disabled', allocationBreakdownInput.is(':checked'))
              .each(function() {
                const $label = $(this);
                if (allocationBreakdownInput.is(':checked')) {
                  $label.attr('title', 'Budget type not supported for allocation breakdowns')
                      .attr('data-placement', 'top')
                      .tooltip();
                } else {
                  $label.tooltip('dispose').removeAttr('title').removeAttr('data-placement');
                }
              });
        });
      };

      const toggleFieldVisibilityBasedOnMetric = function(add_form) {
        setTimeout(function() {
          const budgetMetric = add_form.find('input[id*=budget_metric]:checked').val();
          const showCachingField = budgetMetric === 'impressions' || budgetMetric === 'gross_cost' || budgetMetric === 'net_cost';
          add_form.find('.budget_vast_caching_adjustment').toggleClass('hidden', !showCachingField);
          add_form.find('.budget-currency-addon').toggleClass('hidden', !_.includes(self.currencyMetrics, budgetMetric));
          if (self.defaultVastCachingToTrue === 'true' && showCachingField) {
            add_form.find('input[name$="[vast_caching_adjustment]"]').prop('checked', true);
          }
        }, 0);
      };

      const setupBudgetValueFormatting = (add_form) => {
        const budgetMetric = add_form.find('input[id*=budget_metric]:checked').val();
        const budgetValue = add_form.find('input[id*=budget_value]').val();
        const budgetCurrency = add_form.find('select[name*="[budget_value_currency]"]').val()
            || add_form.find('.budget-currency-addon .input-group-text').text().trim();

        const allowDelimiter = _.includes(self.currencyMetrics, budgetMetric) && (!self.multiCurrencyEnabled || budgetCurrency === "USD");

        const clearValue = cleanNumber(budgetValue);
        if (!clearValue) return;

        const parts = clearValue.split('.');
        // only insert commas for the integer part of the value
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const formatted = allowDelimiter
            ? (parts[1] !== undefined ? integerPart + '.' + parts[1] : integerPart)
            : clearValue;

        add_form.find('input[id*=budget_value]').val(formatted);
      };

      const broadcastSupplyAllocationChange = function() {
        setTimeout(function(){
          $rootScope.$broadcast('budgetSupplyAllocationChange');
        }, 0);
      };

      const broadcastBudgetCountChange = function() {
        setTimeout(function(){
          $rootScope.$broadcast('budgetCountChange', {
            spendId: self.spendId
          });
        }, 0);
      };

      const setInitialBudgetCurrency = function(addedBudget) {
        if (self.rateCurrency && self.rateCurrency !== '') {
          addedBudget.find('select[name*="[budget_value_currency]"]').val(self.rateCurrency);
        }
      };

      const setFlightingActive = function(add_form, flightingActive) {
        add_form.find('.flighting-activator').toggleClass('active', flightingActive);
        add_form.find('.flighting-card').toggleClass('hidden', !flightingActive);
      };

      const visibleBudgetFlightDates = function(add_form) {
        return add_form.find('.budget-flight-dates:not([style*="display: none"])').not('.hidden');
      };

      const budgetTimezone = function() {
        return document.querySelector('select[name$="[budget_timezone]"]').value || 'Etc/UTC';
      };

      const setBudgetFlightDatesInactive = (applyScope) => {
        setTimeout(function() {
          const budgetData = _.map($('.budget-group:not([style*="display: none"])'), function(add_form) {
            const budgetFlights = _.map(visibleBudgetFlightDates($(add_form)).find('input[name$="[flight_dates]"]'), function(input) {
              return $(input).val().split(' - ');
            });

            return [budgetFlights, budgetTimezone()];
          });

          const temp = flightDatesHelper.inactiveByBudgetFlightDates(budgetData);

          if (temp !== budgetFlightDatesInactive) {
            budgetFlightDatesInactive = temp;

            $rootScope.$broadcast('budgetFlightDatesInactiveChange', {
              budgetFlightDatesInactive: budgetFlightDatesInactive,
              applyScope: applyScope
            });
          }
        }, 0);
      };

      const setPacingVisibility = (add_form) => {
        const budgetFlightDatesPacing = add_form.find('input[type="checkbox"][name$="[budget_flight_dates_pacing]"]').prop('checked');

        add_form.find('.budget_pacing').toggleClass('hidden', budgetFlightDatesPacing);
        add_form.find('.budget_flight_date_budget_pacing').toggleClass('hidden', !budgetFlightDatesPacing);
      };

      const matchingCampaignBudgets = function(add_form) {
        const dtPeriod = add_form.find('.budget-period input:checked').val();
        const dtMetric = add_form.find('input[id*=budget_metric]:checked').val() || self.defaultMetric;
        return (self.campaignBudgets || []).filter(function(b) {
          return b.budget_period === dtPeriod && b.budget_metric === dtMetric;
        });
      };

      const periodToLabel = function(period) {
        const map = {
          'hour': 'Hourly',
          'day': 'Daily',
          'week': 'Weekly',
          'month': 'Monthly',
          'lifetime': 'Lifetime',
          'custom': 'Custom'
        };
        return map[period] || '';
      };

      const formatBudgetValue = function(value) {
        if (value == null) {
          return '';
        }
        return String(value);
      };

      const formatFlightDate = function(dateStr) {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit', timeZone: 'UTC' });
      };

      const getBudgetSuffix = function(budget) {
         if (!budget) return 'USD';
        const metric = budget && budget.budget_metric;
        return isCurrencyMetric(metric)
          ? ((budget && budget.budget_value_currency) || 'USD')
          : (typeToLabelMap[metric] || metric || '').replace(':', '').trim();
      };

      const campaignBudgetOptionLabel = function(budget) {
        const flightDates = (budget.budget_flight_dates || []).map(function(fd) {
          return '(' + formatFlightDate(fd.start_date) + '-' + formatFlightDate(fd.end_date) + ')';
        }).join(', ');
        const dateLabel = flightDates ? ' ' + flightDates : '';
        const suffix = getBudgetSuffix(budget);
        return formatBudgetValue(budget.budget_value) + ' ' + suffix + dateLabel;
      };

      const updateCampaignBudgetDisplay = function(add_form, budget) {
        const selectedPeriod = add_form.find('.budget-period input:checked').val();
        add_form.find('.budget-campaign-label').text('Campaign ' + periodToLabel(selectedPeriod) + ' Budget:');
        add_form.find('.budget-campaign-value-display').val(formatBudgetValue(budget && budget.budget_value));
        const suffixLabel = getBudgetSuffix(budget);
        add_form.find('.budget-campaign-value-addon').text(suffixLabel);
      };

      const getSelectedCampaignBudget = function(add_form, matches) {
        const availableMatches = matches || matchingCampaignBudgets(add_form);
        if (availableMatches.length === 1) {
          return availableMatches[0];
        }
        if (availableMatches.length > 1) {
          const selectedId = add_form.find('.budget-campaign-budget-select').val();
          return availableMatches.find(function(b) { return String(b.id) === String(selectedId); });
        }
        return null;
      };

      const setCalculateButtonState = function(add_form, matches) {
        const selectedCampaignBudget = getSelectedCampaignBudget(add_form, matches);
        add_form.find('.budget-calculate-btn').prop('disabled', !selectedCampaignBudget);
      };

      const resetCalculatorTransientState = function(add_form) {
        add_form.find('.budget-percent-input').val('');
        add_form.find('.budget-percent-error').text('').addClass('hidden');
        add_form.find('.budget-campaign-budget-select').val('').trigger('chosen:updated');
        add_form.find('.budget-input-type-toggle label').removeClass('active');
        add_form.find('.budget-input-type-toggle input[value="manual"]').prop('checked', true).closest('label').addClass('active');
        add_form.find('.budget-percent-fields').addClass('hidden');
      };

      const updateCalculatorSection = function(add_form) {
        const matches = matchingCampaignBudgets(add_form);
        const section = add_form.find('.budget-campaign-calculator');
      
        section.toggleClass('hidden', matches.length === 0);
        if (matches.length === 0) {
          resetCalculatorTransientState(add_form);
          setCalculateButtonState(add_form, matches);
          return;
        }
      
        const selector = add_form.find('.budget-campaign-selector');
        const singleDisplay = add_form.find('.budget-campaign-single-display');
        const selectorInput = selector.find('.budget-campaign-budget-select');
      
        if (matches.length >= 2) {
          selector.removeClass('hidden');
          singleDisplay.addClass('hidden');
      
          const previousValue = selectorInput.val();
          selectorInput.empty();
      
          matches.forEach(function(b) {
            selectorInput.append(new Option(campaignBudgetOptionLabel(b), b.id));
          });
      
          const matchingPrevious = matches.find(function(b) { return String(b.id) === String(previousValue); });
          const selectedBudget = matchingPrevious || matches[0];
      
          if (selectedBudget) {
            selectorInput.val(String(selectedBudget.id));
            updateCampaignBudgetDisplay(add_form, selectedBudget);
          }
      
          selectorInput.trigger('chosen:updated');
        } else {
          selector.addClass('hidden');
          singleDisplay.removeClass('hidden');
          updateCampaignBudgetDisplay(add_form, matches[0]);
        }
      
        setCalculateButtonState(add_form, matches);
      };

      const updateAllCalculatorSections = function() {
        visibleBudgetForms().each(function(_, form) {
          updateCalculatorSection($(form));
        });
      };

      this.$onInit = function() {
        budgetsElement = $element.parents('#' + self.spendId);
        try {
          self.campaignBudgets = self.initialCampaignBudgets ? JSON.parse(self.initialCampaignBudgets) : [];
        } catch (e) {
          self.campaignBudgets = [];
        }
        
        const $closestForm = budgetsElement.closest('form');
        if ($closestForm && $closestForm.length) {
          // round all budget values on form submit
          $closestForm.on('submit', function() {
            $('input[id*="_budgets_"][id*="_budget_value"]').each(function() {
                const cleanedValue = cleanNumber($(this).val());
                const convertedValue = Number.parseFloat(cleanedValue);
                if (!isNaN(convertedValue)) {
                  this.value = Math.round(convertedValue);
                }
              });
          });
        }

        bodySelector.on('cocoon:after-insert', '#' + self.spendId, function(e, addedBudget) {
          var that = this;
          addedBudget.find('.budget_pacing .btn-group label[for*=budget_pacing_smooth]').click();
          broadcastSupplyAllocationChange();
          broadcastBudgetCountChange();
          setInitialBudgetCurrency(addedBudget);
          applyFormatToBudgetMetrics(addedBudget, $('input[name$="[format]"]:checked').val());
          updateCalculatorSection(addedBudget);
          setTimeout(function() {
            setBudgetFlightDatesInactive(true);
            if (self.defaultVastCachingToTrue === 'true' && !addedBudget.find('.budget_vast_caching_adjustment').hasClass('hidden')) {
              addedBudget.find('input[name$="[vast_caching_adjustment]"]').prop('checked', true);
            }
            syncAllocationTypeUI();
          }, 0);
        });

        bodySelector.on('cocoon:after-insert', '#budget_flight_dates', function(e, addedBudgetFlightDate) {
          const add_form = $(this).closest('.add_form');
          $(this).find('.datehourrange-future').daterangepicker(platformUtilities.dateRangeFutureOptions);
          togglePacingFields(add_form);
          setBudgetFlightDatesInactive(true);
          setPacingVisibility(add_form);
        });

        bodySelector.on('cocoon:after-remove', '#budget_flight_dates', function(e) {
          const add_form = $(this).closest('.add_form');

          setTimeout(function() {
            if (visibleBudgetFlightDates(add_form).length < 1) {
              add_form.find('.flighting-card .delgroup').click();
            }

            setBudgetFlightDatesInactive(true);
          }, 0);
        });

        bodySelector.on('cocoon:after-remove', '#' + self.spendId, function(e) {
          broadcastSupplyAllocationChange();
          broadcastBudgetCountChange();
          setBudgetFlightDatesInactive(true);
          syncAllocationTypeUI();
        });

        budgetsElement.on('click', '.flighting-activator', function() {
          const add_form = $(this).closest('.add_form');
          setFlightingActive(add_form, true);

          setTimeout(function() {
            if (visibleBudgetFlightDates(add_form).length < 1) {
              add_form.find('.add_budget_flight_date').trigger('click');
            }
          }, 0);
        });

        budgetsElement.on('click', '.flighting-card .delgroup', function() {
          const add_form = $(this).closest('.add_form');
          setFlightingActive(add_form, false);
          visibleBudgetFlightDates(add_form).find('.remove_fields').trigger('click');
          add_form.find('input[type="checkbox"][name$="[budget_flight_dates_pacing]"]').prop('checked', false);

          setTimeout(function() {
            togglePacingFields(add_form);
            setPacingVisibility(add_form);
          }, 0);
        });

        budgetsElement.on('change', 'input[type="checkbox"][name$="[budget_flight_dates_pacing]"]', function() {
          const add_form = $(this).closest('.add_form');
          setPacingVisibility(add_form);
        });

        budgetsElement.on('change', '.budget-period', function() {
          const add_form = $(this).closest('.add_form');
          togglePacingFields(add_form);
          resetCalculatorTransientState(add_form);
          updateCalculatorSection(add_form);
        });
        budgetsElement.on('click', '.budget-calculate-btn', function() {
          const add_form = $(this).closest('.add_form');
          const pctRaw = add_form.find('.budget-percent-input').val();
          const pct = parseFloat(pctRaw);
          const errorEl = add_form.find('.budget-percent-error');
          if (pctRaw === '' || pctRaw == null) {
            errorEl.text('Please enter a percentage.').removeClass('hidden');
            return;
          }
          if (isNaN(pct) || pct <= 0 || pct > 100) {
            errorEl.text('Percentage must be greater than 0 and no more than 100.').removeClass('hidden');
            return;
          }
          const matches = matchingCampaignBudgets(add_form);
          const sourceBudget = getSelectedCampaignBudget(add_form, matches);
          if (!sourceBudget) {
            errorEl.text('No campaign budget selected.').removeClass('hidden');
            return;
          }
          errorEl.text('').addClass('hidden');
          const calculated = Math.round((pct / 100) * sourceBudget.budget_value);
          add_form.find('input[id*=budget_value]').val(calculated).trigger('input');
        });
        budgetsElement.on('change', '.budget-input-type-toggle input', function() {
          const add_form = $(this).closest('.add_form');
          const isPercent = $(this).val() === 'percent';
          add_form.find('.budget-percent-fields').toggleClass('hidden', !isPercent);
          if (!isPercent) {
            add_form.find('.budget-percent-input').val('');
            add_form.find('.budget-percent-error').text('').addClass('hidden');
          }
          setCalculateButtonState(add_form);
        });
        budgetsElement.on('change', '.budget-campaign-budget-select', function() {
          const add_form = $(this).closest('.add_form');
          const matches = matchingCampaignBudgets(add_form);
          const selectedId = $(this).val();
          const selectedBudget = matches.find(function(b) { return String(b.id) === String(selectedId); });
          if (!selectedBudget) {
            setCalculateButtonState(add_form, matches);
            return;
          }
          updateCampaignBudgetDisplay(add_form, selectedBudget);
          setCalculateButtonState(add_form, matches);
        });
        budgetsElement.on('change', '.budget-currency-addon', function() {
          const add_form = $(this).closest('.add_form');
          setupBudgetValueFormatting(add_form);
        });


        budgetsElement.on('change', 'input[name$="[flight_dates]"]', function() {
          setBudgetFlightDatesInactive(true);
        });

        budgetsElement.on('change', 'select[name$="[budget_timezone]"]', function(e) {
          setTimeout(function(){
            $rootScope.$broadcast('budgetTimezoneChange', {
              budgetTimezone: e.target.value
            });
          }, 0);
          setBudgetFlightDatesInactive(true);
        });

        flightDatesElement.on('click', 'label.flight-dates.btn', function() {
          budgetsElement.find('.add_form').each(function(index, add_form) {
            togglePacingFields($(add_form));
          });
        });

        budgetsElement.on('change', 'input[id*=budget_metric]', function() {
          const add_form = $(this).closest('.add_form');
          toggleFieldVisibilityBasedOnMetric(add_form);
          setupBudgetValueFormatting(add_form);
          resetCalculatorTransientState(add_form);
          updateCalculatorSection(add_form);
        });

        budgetsElement.on('change', 'input[type="checkbox"][name$="[ignore_supply_allocations]"]', function() {
          broadcastSupplyAllocationChange();
        });

        $rootScope.$on('formatChanged', function(e, args) {
          budgetsElement.find('.add_form').each(function(_, add_form) {
            applyFormatToBudgetMetrics($(add_form), args.format);
          });
        });

        $rootScope.$on('environmentChange', function(e, args) {
          if (self.demandEnvironment === undefined || self.demandEnvironment === '') {
            return;
          }

          self.demandEnvironment = args.environment;
          clearDomainBreakdownSelections(budgetsElement);
          scheduleBudgetAllocationAttributeRefresh(budgetsElement);
        });

        $rootScope.$on('campaignBudgetsChange', function(e, args) {
          self.campaignBudgets = args.budgets || [];
          updateAllCalculatorSections();
        });

        setTimeout(function() {
          budgetsElement.find('.add_form').each(function(index, add_form) {
            togglePacingFields($(add_form));
            toggleMetricFields($(add_form));
            setupBudgetValueFormatting($(add_form));
            selectAllocationType($(add_form).find('.allocation-breakdown input').is(':checked'), $(add_form));
          });

          clearDomainBreakdownSelections(budgetsElement);
          setBudgetFlightDatesInactive(true);
          scheduleBudgetAllocationAttributeRefresh(budgetsElement);
          syncAllocationTypeUI();
          updateAllCalculatorSections();
        }, 0);

        bodySelector.on('input change', '.budget-cap-percentage input, .budget-value input', function (e) {
          const $input = $(e.target);

          if ($input.closest('.budget-cap-percentage').length) {
            const budget_group = $input.closest('.budget-group');
            const add_form = $input.closest('.add_form');

            const budgetValue = cleanNumber(budget_group.find('.budget-value input').val());
            const percentage = $input.val();
            const metricValue = Math.floor((budgetValue * percentage) / 100);

            add_form.find('.budget-cap-metric-value input').val(metricValue);

          } else if ($input.closest('.budget-value').length) {
            const budgetValue = cleanNumber($input.val())
            const add_form = $input.closest('.add_form');
            setupBudgetValueFormatting(add_form);
            add_form.find('.budget-caps:not([style*="display: none"])').each(function (_, budgetCap) {
              const $budgetCap = $(budgetCap);
              if ($budgetCap.find('.budget-cap-percentage input').is(':visible')) {
                const percentage = $budgetCap.find('.budget-cap-percentage input').val();
                const metricValue = Math.floor((budgetValue * percentage) / 100);
                $budgetCap.find('.budget-cap-metric-value input').val(metricValue);
              }
            });
          }
        });

        const setBudgetCapActive = function(add_form, budgetCapsActive) {
          add_form.find('.allocation-breakdown').toggleClass('active', budgetCapsActive);
          add_form.find('.allocation-type').toggleClass('hidden', !budgetCapsActive);
          add_form.find('.budget-cap-card').toggleClass('hidden', !budgetCapsActive);
        };

        const setBudgetAllocationActive = function(add_form, budgetAllocationsActive) {
          add_form.find('.allocation-breakdown').toggleClass('active', budgetAllocationsActive);
          add_form.find('.allocation-type').toggleClass('hidden', !budgetAllocationsActive);
          add_form.find('.budget-allocation-card').toggleClass('hidden', !budgetAllocationsActive);
        };

        var setBudgetCaps = function () {
          const group = budgetsElement.find('.groupedAssociations');

          setDividerVisibility(group.find('.add_form.budget-caps'));
        };
        var setBudgetAllocations = function () {
          const group = budgetsElement.find('.groupedAssociations');

          setDividerVisibility(group.find('.add_form.budget-allocations'));
        };

        var setDividerVisibility = function(budgetCaps) {
          $.each(budgetCaps, function(index, group) {

            var budgetCapName = index + 1;
            $(budgetCaps).find('.group-name').text(budgetCapName);
            $(budgetCaps).find('.group-input').val(budgetCapName);
          });

          $.each(budgetCaps, function(index, budgetCap) {
            if (budgetCaps.length < 2) {
              $(budgetCap).find('.and').addClass('hidden');
            }
            else {
              $(budgetCap).find('.and').removeClass('hidden');
              var lastVisibleAddForm = _.last(budgetCaps);
              $(lastVisibleAddForm).find('.and').addClass('hidden');
            }
          });
        };

        var toggleBudgetCapsValueAndIdsVisibility = function(add_form) {
          var budgetAllocationObject = add_form.find('.budget-cap-allocation-object select option:selected').val();
          var idsAttribute = add_form.find('.budget-cap-allocation-object select option:selected').data('associationIdsAttr');
          var idsAttributePresent = idsAttribute !== undefined && idsAttribute !== '';
          var valuesOnlyClass = (self.valuesOnlyClassMap || {})[budgetAllocationObject];

          var listRadioLabel = add_form.find('.budget-cap-allocation-source-type label.btn-list');
          var valuesRadioLabel = add_form.find('.budget-cap-allocation-source-type label.btn-values');

          if (valuesOnlyClass) {
            listRadioLabel.addClass('hidden');
            var valuesRadio = valuesRadioLabel.find('input[type="radio"]');
            if (!valuesRadio.is(':checked')) {
              valuesRadio.prop('checked', true);
              valuesRadioLabel.addClass('active');
              listRadioLabel.removeClass('active');
            }
          } else {
            listRadioLabel.removeClass('hidden');
          }

          var sourceType = add_form.find('.budget-cap-allocation-source-type input:checked').val();

          if (sourceType === 'values') {
            if (valuesOnlyClass) {
              add_form.find('.budget-cap-allocation-values.' + valuesOnlyClass).toggleClass('hidden', false).attr('disabled', false);
              add_form.find('.budget-cap-allocation-values:not(.' + valuesOnlyClass + ')').toggleClass('hidden', true).attr('disabled', true);
            } else if (budgetAllocationObject === 'StreamingSellerSeat') {
              add_form.find('.budget-cap-allocation-values.budget-cap-streaming_seller_seat-values').toggleClass('hidden', false).attr('disabled', false);
              add_form.find('.budget-cap-allocation-values:not(.budget-cap-streaming_seller_seat-values)').toggleClass('hidden', true).attr('disabled', true);
            } else {
              add_form.find('.budget-cap-allocation-values.budget-cap-allocation-object-values').toggleClass('hidden', false).attr('disabled', false);
              add_form.find('.budget-cap-allocation-values:not(.budget-cap-allocation-object-values)').toggleClass('hidden', true).attr('disabled', true);
            }
          } else {
            add_form.find('.budget-cap-allocation-values').toggleClass('hidden', true).attr('disabled', true);
          }

          add_form.find('.budget-cap-allocation-list-ids').addClass('hidden');

          if (sourceType === 'list' && idsAttributePresent) {
            add_form.find('.budget-cap-allocation-list-ids.budget-cap-' + idsAttribute).removeClass('hidden');
          }
        };

        bodySelector.on('change', '.budget-cap-allocation-source-type input', function(e) {
          var add_form = $(e.target).closest('.add_form');
          toggleBudgetCapsValueAndIdsVisibility(add_form);

        });

        bodySelector.on('change', '.budget-cap-budget-type input', function(e) {
          const add_form = $(e.target).closest('.add_form');
          const budgetType = add_form.find('.budget-cap-budget-type input:checked').val();
          const budgetValue = cleanNumber($(this).closest('.budget-group').find('.budget-value input').val())
          if (budgetType !== 'percent') {
            add_form.find('.budget-cap-percentage').addClass('hidden');
            add_form.find('#budget_cap_metric_value_field').attr('disabled', false);

            const budgetCapPercentage = add_form.find('.budget-cap-percentage input').val();
            add_form.find('.budget-cap-metric-value input').val(Math.floor((budgetValue * budgetCapPercentage) / 100));
          } else {
            add_form.find('.budget-cap-percentage').removeClass('hidden');
            add_form.find('#budget_cap_metric_value_field').attr('disabled', true);

            const budgetCapMetricValue = add_form.find('#budget_cap_metric_value_field').val()
            add_form.find('.budget-cap-percentage input').val(Math.round((budgetCapMetricValue / budgetValue) * 100));
          }
        });

        bodySelector.on('change', '.budget-metric input', function(e) {
          var selectedType = $(e.target).val();
          var addForm = $(e.target).closest('.add_form');
          updateBudgetCapLabels(addForm, selectedType);
          toggleMetricFields(addForm)
        });

        bodySelector.on('change', '.budget-cap-allocation-object select', function(e) {
          var budgetCapsObject = $(this).val();
          var budgetCapsObjectSelected = budgetCapsObject !== '';
          var add_form = $(e.target).closest('.add_form');

          add_form.find('.budget-cap-allocation-values select option').remove();
          add_form.find('.budget-cap-allocation-values select').val([]).trigger('chosen:updated');
          add_form.find('.budget-cap-list-type, .budget-cap-allocation-source-type').toggleClass('hidden', !budgetCapsObjectSelected);

          toggleBudgetCapsValueAndIdsVisibility(add_form);
          scheduleBudgetAllocationAttributeRefresh($(e.target).closest('.groupedAssociations'));
        });

        function compileAngularJsElements(insertedItem) {
          // only apply this to specific elements because our ``{{CONTENT_ATTRIBUTE_NAME}}` content targeting values get overwritten by AngularJS
          $(insertedItem).find(".angularjs-compile").each((i, compileElement) => {
            // because this is Cocoon, and not AngularJS, we need to tell AngularJS to compile and initialize the new DOM nodes
            $rootScope.$apply(() => {
              const scope = angular.element(compileElement).scope();
              $compile(compileElement)(scope);
            });
          });
        }

        bodySelector.on('cocoon:after-insert', '#budget_caps', function(e, insertedItem) {
          compileAngularJsElements(insertedItem);

          const group = $(e.target).closest('.groupedAssociations');
          const add_form = $(this).closest('.add_form');
          const budgetMetric = add_form.find('input[id*=budget_metric]:checked').val();
          const budgetCaps = $(e.target).closest('.groupedAssociations').find('div:not(.newgroup) .add_form:not([style*="display: none"])').not('.hidden');
          const label = add_form.find('.budget-cap-metric-value-label').last();

          label.text(budgetMetric.charAt(0).toUpperCase() + budgetMetric.slice(1) + ':');

          add_form.find('.budget-cap-budget-type .btn').not('.btn-percent').not('.hidden').last().addClass('active');
          add_form.find('.budget-cap-budget-type .btn input[type="radio"]').not('.btn-percent').not('.hidden').last().prop('checked', true)
          const lastBudgetCap = add_form.find('.budget-caps:not([style*="display: none"]):last');

          const budgetTypeContainer = lastBudgetCap.find('.budget-cap-budget-type');
          const allButtons = budgetTypeContainer.find('.btn');
          const nonPercentButtons = allButtons.not('.btn-percent');
          const targetButton = budgetTypeContainer.find('.' + typeToClassMap[budgetMetric]);

          nonPercentButtons.addClass('hidden');
          targetButton.removeClass('hidden');

          const activeButton = nonPercentButtons.not('.hidden').addClass('active');
          activeButton.find('input[type="radio"]').prop('checked', true);
          allButtons.not(activeButton).removeClass('active');

          initChosenSelects(group);
          setDividerVisibility(budgetCaps);
          scheduleBudgetAllocationAttributeRefresh(group);
        });

        bodySelector.on('cocoon:after-insert', '#budget_allocations', function(e, insertedItem) {
          compileAngularJsElements(insertedItem);

          const budgetAllocations = $(e.target).closest('.groupedAssociations').find('div:not(.newgroup) .add_form:not([style*="display: none"])').not('.hidden');
          const grouped = $(e.target).closest('.groupedAssociations');
          initChosenSelects(grouped);
          setDividerVisibility(budgetAllocations);
          scheduleBudgetAllocationAttributeRefresh(grouped);
          syncAllocationTypeUI();
        });

        bodySelector.on('cocoon:after-remove', '#budget_caps', function(e) {
          const add_form = $(this).closest('.add_form');
          const budgetCaps = $(e.target).closest('.groupedAssociations').find('div:not(.newgroup) .add_form:not([style*="display: none"])').not('.hidden');
          if (budgetCaps.length  === 0) {
            add_form.find('input[type="checkbox"][name$="[allocation_breakdown]"]').prop('checked', false);
            setBudgetCapActive(add_form, false);
            toggleMetricFields(add_form)
          }

          setDividerVisibility(budgetCaps);
          scheduleBudgetAllocationAttributeRefresh($(e.target).closest('.groupedAssociations'));
        });

        bodySelector.on('cocoon:after-remove', '#budget_allocations', function(e) {
          const add_form = $(this).closest('.add_form');
          const budgetAllocations = $(e.target).closest('.groupedAssociations').find('div:not(.newgroup) .add_form:not([style*="display: none"])').not('.hidden');
          if (budgetAllocations.length  === 0) {
            add_form.find('input[type="checkbox"][name$="[allocation_breakdown]"]').prop('checked', false);
            setBudgetAllocationActive(add_form, false);
            toggleMetricFields(add_form);
          }

          setDividerVisibility(budgetAllocations);
          scheduleBudgetAllocationAttributeRefresh($(e.target).closest('.groupedAssociations'));
          syncAllocationTypeUI();
        });

        const visibleBudgetCaps = function(add_form) {
          return add_form.find('.budget-caps:not([style*="display: none"])').not('.hidden');
        };

        const renderInitialBudgetGroups = (add_form) => {
          const allocation_breakdown = add_form.find('.allocation-breakdown input').is(':checked');
          const budgetCapsSize = add_form.find('.budget-caps:not([style*="display: none"])').length
          const budgetAllocationsSize = add_form.find('.budget-allocations:not([style*="display: none"])').length
          const isBudgetCap = add_form.find('.allocation-type input[type="radio"]:checked').val() === BUDGET_CAP_ALLOCATION_TYPE;
          if (isBudgetCap) {
            if (allocation_breakdown && budgetCapsSize === 0) {
              add_form.find('.add_budget_cap').trigger('click');
              add_form.find('.budget-cap-budget-type .btn').not('.btn-percent').not('.hidden').addClass('active');
              add_form.find('.budget-cap-budget-type .btn input[type="radio"]').not('.btn-percent').not('.hidden').last().prop('checked', true)
            }
            setBudgetCapActive(add_form, allocation_breakdown);
          } else if (!isBudgetCap) {
            if (allocation_breakdown && budgetAllocationsSize === 0)
            {
              add_form.find('.add_budget_allocation').trigger('click');
              add_form.find('.add_budget_allocation').trigger('click');
            }
            setBudgetAllocationActive(add_form, allocation_breakdown);
          }
        };

        const existingLeaderAllocationType = function(excludedForm) {
          const otherForm = _.find(visibleBudgetForms().toArray(), function(form) {
            return $(form).get(0) !== excludedForm.get(0) && allocationBreakdownEnabled($(form)) && Boolean(selectedAllocationType($(form)));
          });
          return otherForm ? selectedAllocationType($(otherForm)) : null;
        };

        const selectAllocationType = (allocationBreakdown, add_form) => {
          if (allocationBreakdown && add_form.find('.allocation-type input[type="radio"]:checked').val() === undefined) {
            const hasAllocation = add_form.find('input[id*="allocation_type__allocation"]').length > 0;
            const hasBudgetCap = add_form.find('input[id*="allocation_type_budget_cap"]').length > 0;
            const leaderType = existingLeaderAllocationType(add_form);

            let targetValue = null;
            if (leaderType === BUDGET_CAP_ALLOCATION_TYPE && hasBudgetCap) {
              targetValue = BUDGET_CAP_ALLOCATION_TYPE;
            } else if (hasAllocation) {
              targetValue = PERCENTAGE_ALLOCATION_TYPE;
            } else if (hasBudgetCap) {
              targetValue = BUDGET_CAP_ALLOCATION_TYPE;
            }

            if (targetValue) {
              add_form.find(`.allocation-type input[type="radio"][value="${targetValue}"]`).closest('label').click();
            }
          }
        }

        bodySelector.on('click', '.allocation-breakdown', function (e) {
          const add_form = $(this).closest('.add_form');

          renderInitialBudgetGroups(add_form);
          toggleMetricFields(add_form);
          selectAllocationType(e.target.checked, add_form);
          if (budgetUsesPercentageAllocation(add_form)) {
            applyPercentageAllocationReferenceAttributes(add_form);
          }
          syncAllocationTypeUI();
          scheduleBudgetAllocationAttributeRefresh(add_form);
        });

        bodySelector.on('click', '.budget-cap-card .budget-cap-delgroup', function(e) {
          const add_form = $(this).closest('.add_form');
          setBudgetCapActive(add_form, false);
          visibleBudgetCaps(add_form).find('.remove_fields').trigger('click');
          toggleMetricFields(add_form)
          add_form.find('input[type="checkbox"][name$="[allocation_breakdown]"]').prop('checked', false);
          syncAllocationTypeUI();
        });

        bodySelector.on('click', '.budget-allocation-card .budget-allocation-delgroup', function(e) {
          const add_form = $(this).closest('.add_form');
          setBudgetAllocationActive(add_form, false);
          visibleBudgetAllocations(add_form).find('.remove_fields').trigger('click');
          add_form.find('input[type="checkbox"][name$="[allocation_breakdown]"]').prop('checked', false);
          toggleMetricFields(add_form);
          syncAllocationTypeUI();
        });

        bodySelector.on('change', '.allocation-type', function () {
          const add_form = $(this).closest('.add_form');
          const isBudgetCap = add_form.find('.allocation-type input[type="radio"]:checked').val() === BUDGET_CAP_ALLOCATION_TYPE;
          add_form.find('.budget-cap-card').toggleClass('hidden', !isBudgetCap);
          add_form.find('.budget-allocation-card').toggleClass('hidden', isBudgetCap);

          renderInitialBudgetGroups(add_form);
          if (budgetUsesPercentageAllocation(add_form)) {
            applyPercentageAllocationReferenceAttributes(add_form);
          }
          syncAllocationTypeUI();
          scheduleBudgetAllocationAttributeRefresh(add_form);
        });

        bodySelector.on('click', '.allocation-type label.disabled', function(e) {
          e.preventDefault();
          return false;
        });

        var initChosenSelects = function(selector) {
          $.each($(selector).find('select[data-ajax]:not([data-tom-select])'), function(index, select){
            var selector = $(select);
            if (selector.data('ajax') === 'select' || selector.parent().find('.tokenize').length < 1) {
              selector.defaultTokenize();
            }
          });
          $.each($(selector).find('select[data-tom-select]'), function(index, select){
            $(select).defaultTomSelect();
          });
          $.each($(selector).find('select[data-dynamic-chosen]'), function(index, select){
            $(select).dynamicChosen();
          });
          $.each($(selector).find('select:not([data-ajax]):not([data-tom-select]):not([data-dynamic-chosen])'), function(index, select){
            $(select).defaultChosen();
          });
        };

        setBudgetCaps()
        setBudgetAllocations()
      };

    }]
  });
